export default "__VITE_ASSET__Bx7yx1s9__"